import { render, staticRenderFns } from "./editScores.vue?vue&type=template&id=d64c082e&scoped=true&"
import script from "./editScores.vue?vue&type=script&lang=js&"
export * from "./editScores.vue?vue&type=script&lang=js&"
import style0 from "./editScores.vue?vue&type=style&index=0&id=d64c082e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64c082e",
  null
  
)

export default component.exports